import { render, staticRenderFns } from "./LinkPromotionsAddNew.vue?vue&type=template&id=791b6f14"
import script from "./LinkPromotionsAddNew.vue?vue&type=script&lang=js"
export * from "./LinkPromotionsAddNew.vue?vue&type=script&lang=js"
import style0 from "./LinkPromotionsAddNew.vue?vue&type=style&index=0&id=791b6f14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports